import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import * as selector from '../../selectors/selectors'
import CustomSwitch from '../shared/switch.component'
import { ActionLabels, appNote } from '../shared/constants'
import SettingsHeader from './settingsHeader.component'
import { Grid } from '@mui/material'
import { SettingsService } from '../../services/SettingsService'
import Confirm_Dialog from '../shared/confirm-dialog.component'
import { UpdateSettings } from '../../actions'
import { useDispatch } from 'react-redux'
type Props = {}
const FeatureFlag = ({ }: Props) => {
    const dispatch = useDispatch()
    const hide = ["SATZ", "TFA", "WNA", "MPC", "MMC", "MGC", "BLCKMEDIA", "BLCKLINKS", "UNSUBSCRIBE", "MS", "LOWCRDT", "STAM", "PNFOM", "SIGN", "TMZ", "TC", "THEME", "MSL", "OPTINCOLLECT", "KEYWORD", "SPNA", "UNARCHIVE"]
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const Settings = useSelector(selector.settings)
    const [showDialogue, setShowDialogue] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [ButtonName, setButtonName] = useState<string>("");
    const [switchType, setSwitchType] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedFeature, setSelectedFeature] = useState<any>(null);

    const handleSwitch = (checked: boolean, type: string, feature: any) => {
        let text = "";
        switch (type) {
            case SettingsService.Auto_Replay:
                text = checked
                    ? appNote.AUTO_REPALY_ENABLE_MESSAGE
                    : appNote.AUTO_REPALY_DISABLE_MESSAGE;
                break;
            case SettingsService.Group_Chat:
                text = checked
                    ? appNote.GROUP_CHAT_ENABLE_MESSAGE
                    : appNote.GROUP_CHAT_DISABLE_MESSAGE;
                break;
            case SettingsService.MMS:
                text = checked
                    ? appNote.MMS_ENABLE_MESSAGE
                    : appNote.MMS_DISABLE_MESSAGE;
                break;
            case SettingsService.Schedule_Messages:
                text = checked
                    ? appNote.SCHEDULE_MESSAGES_ENABLE_MESSAGE
                    : appNote.SCHEDULE_MESSAGES_DISABLE_MESSAGE;
                break;
            case SettingsService.Secure_chat:
                text = checked
                    ? appNote.SECURE_CHAT_ENABLE_MESSAGE
                    : appNote.SECURE_CHAT_DISABLE_MESSAGE;
                break;
            case SettingsService.Secure_File:
                text = checked
                    ? appNote.SECURE_FILE_ENABLE_MESSAGE
                    : appNote.SECURE_FILE_DISABLE_MESSAGE;
                break;
            case SettingsService.Transfer_Chat:
                text = checked
                    ? appNote.TRANSFER_CHAT_ENABLE_MESSAGE
                    : appNote.TRANSFER_CHAT_DISABLE_MESSAGE;
                break;
            case SettingsService.Secure_Doc:
                text = checked
                    ? appNote.SECURE_DOC_ENABLE_MESSAGE
                    : appNote.SECURE_DOC_DISABLE_MESSAGE;
                break;
            case SettingsService.Enable_Ai_Features:
                text = checked
                    ? appNote.AI_FEATURES_ENABLE_MESSAGE
                    : appNote.AI_FEATURES_DISABLE_MESSAGE;
                break;
            default:
                break;
        }
        openConfirmDialog(text, checked ? ActionLabels.ENABLE : ActionLabels.DISABLE, type, feature);
    }

    const openConfirmDialog = (text: any, action: string, type: string, feature: any) => {
        // var user = JSON.parse(localStorage.getItem("current-user")?.toString()!);
        // LoadOrgName(dispatch, user.organizationId);
        setShowDialogue(true)
        setText(text)
        setButtonName(action)
        setSwitchType(type)
        setSelectedFeature(feature)
        setIsLoading(false)
    }



    const closeConfirmDialog = (isConfirm: boolean) => {
        let btnLabel = ButtonName;
        if (isConfirm) {
            setShowDialogue(false)
            UpdateSettings(dispatch, {
                id: selectedFeature?.ID,
                name: selectedFeature?.Name,
                code: selectedFeature?.Code,
                value: btnLabel === ActionLabels.ENABLE ? "True" : "False",
            });

        } else {
            setShowDialogue(false)
        }
        setShowDialogue(false)
    };
    return (
        <div className={`m-auto h-p-100 `}>
            <div className={`d-flex flex-direction w-p-99 ${IsMobileDevice ? "" : "mt-2"}`}>
                <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Feature Flags"} subTitle={"Control features in your account"} version={false} />
            </div>
            <div className='h-p-95 w-p-99'>
                {
                    Settings.filter(x => !hide.includes(x.Code)).map((feature, index) => (
                        <div className={`${IsMobileDevice ? 'mt-1' : "settings-border br-2 mt-1"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {feature.Name}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={feature.Value?.toString().toLowerCase() === "true"}
                                            onChange={(checked: boolean) => handleSwitch(checked, feature.Code, feature)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    ))
                }
            </div>
            <Confirm_Dialog
                onClose={closeConfirmDialog}
                Show={showDialogue}
                Text={text}
                ButtonName={ButtonName}
                Loading={isLoading}
                IsMobileDevice={IsMobileDevice}
            />
        </div>
    )
}

export default FeatureFlag